<template>
	<div class="container-modal form-modal">
		<div class="container-holder">
			<div class="header-modal">
				<div class="icon"><icon-cart /></div>
				<div class="title">Date <span class="yellow">Facturare</span></div>
				<div class="description">Completează datele de facturare cu atenție. Toate câmpurile de mai jos sunt obligatorii.</div>
			</div>

			<div class="form-section">
				<div class="input-group-tbf w-mob-100">
					<div class="input-box">
						<div class="icon-right-new"><icon-dots /></div>
						<div class="required-icon">*</div>
						<multiselect
						class="select-tags-tbf"
						v-model="selectedTypePerson"
						:options="['company', 'individual']" 
						:show-labels="false"
						:allow-empty="false"
						:searchable="false"
						@input="changeTypePerson">
							<template slot="singleLabel" slot-scope="props">
								<span class="option__title">{{ $t('register_options.' + props.option) }}</span>
							</template>
							<template slot="option" slot-scope="props">
								<span class="option__title">{{ $t('register_options.' + props.option) }}</span>
							</template>
						</multiselect>
					</div>
				</div>

				<div class="input-group-tbf w-mob-100" v-bind:class="{has_error: $v.user.complet_name.$error, complete: user.complet_name != '' && !$v.user.complet_name.$error}" v-if="selectedTypePerson == 'individual'">
					<div class="input-box">
						<div class="icon-right-new"><icon-people /></div>
						<div class="required-icon">*</div>
						<input type="text" :placeholder="$t('register.complet_name')" class="input-text" v-model="user.complet_name" ref="first_input">
					</div>
				</div>

				<div class="input-group-tbf w-mob-100" v-bind:class="{has_error: $v.user.cnp.$error, complete: user.cnp != '' && !$v.user.cnp.$error }" v-if="selectedTypePerson == 'individual'">
					<div class="input-box">
						<div class="icon-right-new"><icon-cnp /></div>
						<div class="required-icon">*</div>
						<input type="text" :placeholder="$t('register.cnp')" class="input-text" v-model="user.cnp">
					</div>
				</div>

				<div class="input-group-tbf w-mob-100" v-bind:class="{has_error: $v.user.company_name.$error, complete: user.company_name != '' && !$v.user.company_name.$error}" v-if="selectedTypePerson == 'company'">
					<div class="input-box">
						<div class="icon-right-new"><icon-building /></div>
						<div class="required-icon">*</div>
						<input type="text" :placeholder="$t('register.company')" class="input-text" v-model="user.company_name">
					</div>
				</div>

				<div class="input-group-tbf w-mob-100" v-bind:class="{has_error: $v.user.company_cui.$error, complete: user.company_cui != '' && !$v.user.company_cui.$error}" v-if="selectedTypePerson == 'company'">
					<div class="input-box">
						<div class="icon-right-new"><icon-cui /></div>
						<div class="required-icon">*</div>
						<input type="text" :placeholder="$t('register.cui')" class="input-text" v-model="user.company_cui">
					</div>
					<div class="error-msg" v-if="invalidCui">{{ $t('validator.cui_invalid') }}</div>
				</div>

				<div class="input-group-tbf w-mob-100" v-bind:class="{has_error: $v.user.bank_name.$error, complete: user.bank_name != '' && !$v.user.bank_name.$error}" v-if="selectedTypePerson == 'company'">
					<div class="input-box">
						<div class="icon-right-new"><icon-cui /></div>
						<div class="required-icon">*</div>
						<input type="text" :placeholder="$t('register.bank_name')" class="input-text" v-model="user.bank_name">
					</div>
				</div>

				<!-- end date facturare -->
				<div class="input-group-tbf checkboxes-group">
					<label class="checkbox-tbf no-margin" v-bind:class="{'error-msg': $v.user.terms_and_conditions.$error}">
						<span class="text-checkbox" v-html="$t('register.terms', {terms_link: 'https://tbf.ro/termeni-si-conditii-generale'})">
						</span>
						<input type="checkbox" value="1" v-model="user.terms_and_conditions">
						<span class="checkmark"></span>
					</label>						
				</div>
			</div>
			<div class="submit-form">
				<button class="button-submit" id="buttonSubmitStep21" @click="goNextStep">
					<div class="loader-spin" v-if="loadingSubmit"></div>
					<div class="text" v-else>{{$t('register.button-action-2')}}</div>
				</button>
			</div>
		</div>
	</div>
</template>


<script>
	import CloseIcon from '../Icons/Close'
	import IconPlus from "../Icons/Plus"
	import IconInfo from "../Icons/Info"
	import IconFolder from "../Icons/Folder"
	import IconArrow from "../Icons/Arrow"
	import IconPeople from "../Icons/People"
	import IconCircleCheck from "../Icons/CircleCheck"
	import InformationIcon from '../Icons/Information'
	import IconIndividual from '../Icons/Individual'
	import IconOffice from '../Icons/Office'
	import IconCnp from '../Icons/Cnp'
	import IconBuilding	from '../Icons/Building'
	import IconCui	from '../Icons/Cui'
	import UserSettingsIcon from '../Icons/UserSettings';
	import SettingsGoalIcon from '../Icons/SettingsGoal';
	import IconObjectivesList from '../Icons/ObjectivesList'
	import PasswordIcon from '../Icons/Password';
	import IconCart from '../Icons/Cart'
	import IconDots from '../Icons/Dots'
	import { required, minLength, requiredIf, sameAs } from 'vuelidate/lib/validators'

	export default {
		data(){
			return {
				optionsCountry: [],
				value_country: '',
				selectedTypePerson: 'company',
				invalidCui: '',
				activeTooltip: '',
				termsNotAccepted: '',
				cardErrors: {},
				errorCoupon: false,
				subModalShow: false,
				loadingSubmit: false
			}
		},
		props:{
			user: Object
		},
		components: {
			CloseIcon,
			IconPlus,
			IconInfo,
			IconFolder,
			IconArrow,
			IconPeople,
			IconCircleCheck,
			InformationIcon,
			IconIndividual,
			IconOffice,
			IconBuilding,
			IconCnp,
			IconCui,
			UserSettingsIcon,
			SettingsGoalIcon,
			IconObjectivesList,
			PasswordIcon,
			IconCart,
			IconDots
		},
		validations: {
			value_country: {required},
			selectedTypePerson: {required},
			user: {
				terms_and_conditions: { sameAs: val => val === true },
				first_name: {required},
				last_name: {required},
				has_company: '',	
				company_name: {
			        requiredIf: requiredIf((user) => {
			          return user.has_company == 1 || user.has_company === '' 
			        })
			    },
			    bank_name: {
					requiredIf: requiredIf((user) => {
			          return user.has_company == 1 || user.has_company === '' 
			        })
				},
				company_cui: {
					requiredIf: requiredIf((user) => {
			          return user.has_company == 1 || user.has_company === '' 
			        })
				},
				complet_name: {
					requiredIf: requiredIf((user) => {
			          return user.has_company == 0
			        })
				},
				cnp: {
					requiredIf: requiredIf((user) => {
			          return user.has_company == 0 
			        }), 
					minLength: minLength(13)
				},
			}
		},
		watch: {},
		async mounted() {
			this.user.complet_name = this.user.last_name + ' ' + this.user.first_name
			await this.getPackages();
			await this.getCountries();
		},
		methods: {
			async getPackages() {
				await axios.get("packages").then(({ data }) => {
					this.packagesList = data.reverse();
					if (this.$route.query.reducere) {
						this.packageActive = this.packagesList.find((el) => el.token == this.$route.query.reducere);
						if (this.packageActive) {
							this.user.packageActive = this.packageActive;
						} else {
							this.packageActive = this.packagesList.find((el) => el.token == "33e71c8436036b299a0dabfb534a28058");
							this.user.packageActive = this.packageActive;
						}
					} else {
						// default merge pe Curs de management pret intreg
						this.packageActive = this.packagesList.find((el) => el.token == "33e71c8436036b299a0dabfb534a28058");
						this.user.packageActive = this.packageActive;
					}
					this.packagesList = [this.packageActive];
				});
			},
			async getCountries(){
				await axios.get('/countries').then(({data}) => {
					this.optionsCountry = data.data
					this.value_country = this.optionsCountry.find(el => el.iso == this.user.language.toUpperCase())
					this.user.country = this.value_country
				})
			},
			goNextStep(){
				var btnSubmit = document.getElementById('buttonSubmitStep21');
				btnSubmit.disabled = true;
				this.loadingSubmit = true;

				this.$v.$touch()
				if(this.$v.$invalid){
					btnSubmit.disabled = false;
					this.loadingSubmit = false;
				}else {
					this.submitRegister();
				}
			},
			submitRegister(){
				var btnSubmit = document.getElementById('buttonSubmitStep21');
				this.invalidCui = false;
				var app = this

				var formData = {
					first_name: this.user.first_name,
					last_name: this.user.last_name,
					password: this.user.password,
					phone: this.user.phone,
					email: this.user.email,
					language: this.user.language,
					country_id: this.user.country.id,
					has_company: this.user.has_company,
					agree_with_terms: this.user.terms_and_conditions,
					package_token: this.user.packageActive.token,
					referral_uuid: this.user.referral_uuid,
					coupon: this.user.coupon
				}
				if(this.user.has_company){
					formData.company_name = this.user.company_name
					formData.cui = this.user.company_cui
					formData.bank_name = this.user.bank_name
				}else{
					formData.name = this.user.complet_name
					formData.cnp = this.user.cnp
				}

				this.$auth.register({
					data: formData,
					dataType: 'json',
					success: function () {
						this.$auth.login({
							data: {
								email: app.user.email,
								password: "testing123"
							}, 
							success: function() {
								setTimeout(()=>{
									app.$router.replace('/payment?token=' + this.$auth.user().package.token)
									app.$emit("next_step", {user: app.user, next_step: 3});
								}, 500)
							},
							error: function (res) {
								btnSubmit.disabled = false;
								this.loadingSubmit = false;
							},
							rememberMe: true,
							fetchUser: true,
						});
					},
					error: function (res) {
						this.invalidCui = true
						btnSubmit.disabled = false;
						this.loadingSubmit = false;
					},
					rememberMe: true,
					fetchUser: true,
				});
			},

			selectCountry(value, id){
				this.user.country = value
			},
			closeModal(){
				this.$router.push("/login");
			},
			closeModalCoupon() {
				this.subModalShow = false;
			},
			changeTypePerson(type) {
				this.selectedTypePerson = type;
				if(this.selectedTypePerson == 'company'){
					this.user.has_company = 1;
				}else{
					this.user.has_company = 0;
				}
			},
			displayModal(){
				this.subModalShow = true;
			}
		}
	}
</script>